// <asria-editeur-de-modele> (CRM-344 ; ADR 20261103_CorpsDesModelesDeCommunication §4 ; exception écrite à la spec 04
// E-3.3) : la vue Elm le pose comme un nœud ordinaire. Il reçoit le document du back par l'attribut `document`, une
// commande de la barre d'outils par l'attribut `commande` (JSON avec un `jeton` qui change à chaque geste), et rend
// chaque modification par l'événement `modification` (`detail.document`, au format du back), et le bloc Image
// sélectionné par l'événement `image-selectionnee` (`detail.image` : ses réglages, ou null ; M416 M11). L'attribut
// `lecture-seule` le rend non modifiable (Paramétrage en lecture, M416 M1). Aucun port.
import { versEditeur, depuisEditeur } from "./corpsDeModele.js";

const nom = "asria-editeur-de-modele";

function lireJson(texte) {
  try {
    return texte ? JSON.parse(texte) : null;
  } catch {
    return null;
  }
}

class EditeurDeModele extends HTMLElement {
  static get observedAttributes() {
    return ["document", "commande", "lecture-seule"];
  }

  connectedCallback() {
    if (this.chargement) return;
    // Tiptap n'est téléchargé qu'ici, à la première pose de l'éditeur
    this.chargement = import("./editeurTiptap.js").then((module) => {
      this.module = module;
      if (!this.isConnected) return;
      this.dernier = this.getAttribute("document");
      this.editeur = module.creerEditeur(
        this,
        versEditeur(lireJson(this.dernier)),
        this.getAttribute("libelle"),
        (doc) => {
          const corps = depuisEditeur(doc);
          this.dernier = JSON.stringify(corps);
          this.dispatchEvent(new CustomEvent("modification", { detail: { document: corps } }));
        },
        (image) => this.dispatchEvent(new CustomEvent("image-selectionnee", { detail: { image } })),
      );
      this.editeur.setEditable(!this.hasAttribute("lecture-seule"));
    });
  }

  disconnectedCallback() {
    if (this.editeur) this.editeur.destroy();
    this.editeur = null;
    this.chargement = null;
  }

  attributeChangedCallback(attribut, avant, apres) {
    if (!this.editeur || avant === apres) return;
    if (attribut === "document" && apres !== this.dernier) {
      // Un document qui ne vient pas de la frappe (autre langue, version relue) remplace le contenu
      this.dernier = apres;
      this.editeur.commands.setContent(versEditeur(lireJson(apres)), { emitUpdate: false });
    }
    if (attribut === "lecture-seule") this.editeur.setEditable(apres === null);
    if (attribut === "commande") {
      const commande = lireJson(apres);
      if (commande) this.module.jouer(this.editeur, commande);
    }
  }
}

if (!customElements.get(nom)) customElements.define(nom, EditeurDeModele);
